export enum PROJECT_TYPES {
  GLASS_CALC = 'glass-calculator',
  MASTER_KRONAS = 'KMaster',
  SLIDING_CONSTRUCTOR = 'sliding',
}
